import { Box, Typography, TextField, Tooltip, IconButton, LinearProgress, Button } from '@mui/material'
import { Refresh as RefreshIcon, Add as AddIcon } from '@mui/icons-material'
import { useClassification } from '../../../shared/context/classificactionContext'
import { useEffect } from 'react'
import { useUtiles } from '../../../shared/context/utilesContext'
import CreateClassificationComponent from './CreateClassificationComponent'
import { useTheme } from '@mui/material/styles'

export default function SelectClassificationComponent({ type_asset, number, setSelectClassification }) {
    const { classifications, loading, getClassification, setClassifications } = useClassification()
    const { toogleOpenSilder, saveCurrentComponent, openSilderWith } = useUtiles()
    const theme = useTheme()
    
    useEffect(() => {
        setClassifications([])
        getClassification({ type_asset, number })
    }, [])

    const handleSearch = (e) => {
        getClassification({ type_asset, search: e.target.value, number: number })
    }

    const handleSelectClassification = (classification) => {
        setSelectClassification(classification)
        toogleOpenSilder(null, 500, '')
    }
    
    const handleOpenCreateClassification = () => {
        // Guardar el componente actual antes de abrir el nuevo
        saveCurrentComponent()
        
        // Abrir el componente de creación de clasificación usando openSilderWith
        openSilderWith(
            <CreateClassificationComponent type_asset={type_asset} number={number} />,
            500,
            'Crear Nueva Clasificación'
        )
    }

    return (
        <Box sx={{ padding: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <TextField fullWidth placeholder="Escribe para buscar" size="small" onChange={handleSearch} />
                <Tooltip title="Refrescar">
                    <IconButton size="small" onClick={() => getClassification({ type_asset })}>
                        <RefreshIcon  />
                    </IconButton>
                </Tooltip>
            </Box>
            <Button 
                size="small" 
                variant="contained" 
                color="primary" 
                sx={{ mt: 1 }} 
                onClick={handleOpenCreateClassification}
                startIcon={<AddIcon />}
            >
                Crear Clasificación
            </Button>

            { loading && <LinearProgress sx={{ mt: 2 }} />}

            <Box sx={{ mt: 2, maxHeight: '70vh', overflow: 'auto' }}>
                {classifications.map((classification) => (
                    <Box 
                        key={classification.id}
                        onClick={() => handleSelectClassification(classification, number)}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            p: 1.5,
                            mb: 1,
                            borderRadius: '8px',
                            backgroundColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.02)',
                            transition: 'all 0.2s',
                            cursor: 'pointer',
                            '&:hover': {
                                backgroundColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)',
                                transform: 'translateY(-2px)',
                                boxShadow: '0 4px 8px rgba(0,0,0,0.05)'
                            }
                        }}
                    >
                        <Box 
                            sx={{ 
                                mr: 2,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: 40,
                                height: 40,
                                borderRadius: '50%',
                                backgroundColor: (theme) => theme.palette.primary.main,
                                color: '#fff'
                            }}
                        >
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5 5H19C19.5523 5 20 5.44772 20 6V18C20 18.5523 19.5523 19 19 19H5C4.44772 19 4 18.5523 4 18V6C4 5.44772 4.44772 5 5 5Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M4 9H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                <path d="M8 14H16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                        </Box>
                        <Box sx={{ flex: 1 }}>
                            <Typography 
                                variant="body1" 
                                sx={{ 
                                    fontWeight: 500,
                                    color: (theme) => theme.palette.text.primary
                                }}
                            >
                                {classification.value}
                            </Typography>
                        </Box>
                    </Box>
                ))}
            </Box>
        </Box>
    )
}